<template>
    <div class="trip-device-cell d-inline-flex align-items-center flex-wrap">
        <button type="button" class="btn mr-2 mb-1 d-inline-flex align-items-center live-tracking-cell__button"
            :class="trackingButtonClass"
            :title="trackingButtonTitle"
            @click.prevent="openPositionModal">
            <span class="trip-device-cell__status-dot" :class="{ 'trip-device-cell__status-dot--assigned': hasAssignedTracker }"></span>
            <span class="trip-device-cell__label">{{ trackerLabel }}</span>
            <span class="btn btn-link text-secondary p-0 ml-2 d-inline-flex align-items-center trip-device-cell__trigger"
                :title="$t('current_position')">
                <app-icon name="map-pin" class="size-18" />
            </span>
        </button>
        <trip-current-position-modal v-if="isPositionModalActive" :key="positionModalKey" :trip-data="rowData"
            @close-modal="closePositionModal" />
    </div>
</template>

<script>
export default {
    name: 'TripDeviceCell',
    props: {
        value: {
            default: null,
        },
        rowData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isPositionModalActive: false,
            positionModalKey: 0,
        };
    },
    computed: {
        hasAssignedTracker() {
            return Boolean(this.directTrackerName || this.directTrackerImei);
        },
        directTrackerName() {
            return this.rowData.active_device_name || '';
        },
        directTrackerImei() {
            return this.rowData.active_device_imei || '';
        },
        trackerLabel() {
            return this.directTrackerImei || this.directTrackerName || this.$t('live_tracking_off');
        },
        trackingButtonClass() {
            return this.hasAssignedTracker
                ? 'live-tracking-cell__button--assigned'
                : 'live-tracking-cell__button--unassigned';
        },
        trackingButtonTitle() {
            return this.hasAssignedTracker ? this.$t('live_tracking') : this.$t('live_tracking_off');
        },
    },
    methods: {
        openPositionModal() {
            this.positionModalKey += 1;

            if (this.isPositionModalActive) {
                this.isPositionModalActive = false;
                this.$nextTick(() => {
                    this.isPositionModalActive = true;
                });
                return;
            }

            this.isPositionModalActive = true;
        },
        closePositionModal() {
            this.isPositionModalActive = false;
        },
    },
}
</script>

<style scoped>
.trip-device-cell__badge {
    padding: 0.45rem 0.8rem;
    border: 1px solid rgba(var(--brand-primary-rgb), 0.12);
    background: linear-gradient(135deg, rgba(var(--brand-primary-rgb), 0.16), rgba(var(--brand-primary-rgb), 0.06));
    color: #16324a;
    box-shadow: none;
}

.trip-device-cell__label {
    font-weight: 600;
    letter-spacing: 0.01em;
}

.trip-device-cell__status-dot {
    width: 0.58rem;
    height: 0.58rem;
    margin-right: 0.5rem;
    border-radius: 999px;
    background: #dc2626;
    box-shadow: 0 0 0 4px rgba(220, 38, 38, 0.12);
    flex: 0 0 auto;
}

.trip-device-cell__status-dot--assigned {
    background: #16a34a;
    box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.12);
}

.trip-device-cell__count {
    border: 1px solid rgba(15, 23, 42, 0.08);
    background: rgba(15, 23, 42, 0.72);
    color: #fff;
}

.trip-device-cell__trigger {
    position: relative;
    color: #d94343 !important;
    overflow: visible;
    border-radius: 999px;
    transition: transform 180ms ease, color 180ms ease;
}

.live-tracking-cell__button--assigned .trip-device-cell__trigger {
    color: #16a34a !important;
}

.live-tracking-cell__button--assigned .trip-device-cell__trigger::after {
    background: rgba(22, 163, 74, 0.18);
}

.trip-device-cell__trigger::after {
    content: '';
    position: absolute;
    inset: -0.35rem;
    border-radius: 999px;
    background: rgba(217, 67, 67, 0.18);
    animation: trip-device-pin-pulse 1.9s ease-out infinite;
}

.trip-device-cell__trigger:hover {
    transform: translateY(-1px) scale(1.05);
    color: #bf2d2d !important;
}

.trip-device-cell__trigger .app-icon,
.trip-device-cell__trigger svg {
    position: relative;
    z-index: 1;
}

@keyframes trip-device-pin-pulse {
    0% {
        transform: scale(0.45);
        opacity: 0.95;
    }

    70% {
        transform: scale(1.3);
        opacity: 0;
    }

    100% {
        transform: scale(1.3);
        opacity: 0;
    }
}

.live-tracking-cell__button {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 0.28rem 0.7rem;
    font-size: 0.8rem;
    line-height: 1.2;
    white-space: nowrap;
}

.live-tracking-cell__button--assigned {
    border-color: rgba(22, 163, 74, 0.28);
    background: rgba(22, 163, 74, 0.08);
    color: #166534;
}

.live-tracking-cell__button--unassigned {
    border-color: rgba(220, 38, 38, 0.24);
    background: rgba(220, 38, 38, 0.08);
    color: #b91c1c;
}
</style>
